import { Directive, Input, HostListener } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";

@Directive({
    selector: "[appOperationHistory]"
})
export class OperationHistoryDirective {
    @Input() contractId: string;
    @Input() contract: Contract;
    @Input() getContract = true;

    @Input() oldValue: string;
    @Input() newValue: string;

    @Input() appOperationHistory: string;

    constructor(private operationHistoryService: OperationHistoryService, private readonly store: Store<IAppState>) {}

    @HostListener("click", ["$event"]) onClick($event) {
        this.registerOperation();
    }

    private register() {

        if (this.appOperationHistory) {
            let contractId = "";

            if (this.contractId) {
                contractId = this.contractId;
            } else if (this.contract && this.contract.ContractId) {
                contractId = this.contract.ContractId;
            }

            this.operationHistoryService.registerWithContract(
                contractId,
                this.appOperationHistory,
                this.newValue,
                this.oldValue
            );
        }
    }

    private getSelectedContract() {
        this.store.pipe(select(getContract)).subscribe(c => {
            this.contract = c;
            this.register();
        });
    }

    private registerOperation() {
        if (this.getContract) {
            this.getSelectedContract();
            return
        }
        this.register();
    }
}
